module.exports = __webpack_public_path__ + "static/media/CedulaMano.1cc3d356.svg";